const bridge = () => typeof window !== "undefined" ? window.desktopOfflineBillingHistory : null;

export const listOfflineBillingHistory = (restaurantId, options = {}) => {
  const api = bridge();
  if (!api?.list) {
    throw new Error("Restart the desktop app to initialize offline Billing History.");
  }
  return api.list({ restaurantId, ...options });
};
